var Backbone, SupportAPIHelper, SupportOrderModel, SupportUtilsHelper, async,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../helpers/API');

async = require('../../../../core/frontend/vendor_modules/async');

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

SupportOrderModel = (function(superClass) {
  extend(SupportOrderModel, superClass);

  function SupportOrderModel() {
    this.orderDetailMap = {};
    this.orderMetadataMap = {};
  }

  SupportOrderModel.prototype.findOrderDetailsByOrderId = function(orderId) {
    if (orderId) {
      orderId = orderId.toString();
      return this.orderDetailMap[orderId];
    } else {
      return null;
    }
  };

  SupportOrderModel.prototype.setOrderDetails = function(order) {
    var orderId;
    if (order != null ? order.id : void 0) {
      orderId = order.id.toString();
      return this.orderDetailMap[orderId] = order;
    }
  };

  SupportOrderModel.prototype.findOrderMetaDataByOrderId = function(orderId) {
    if (orderId) {
      orderId = orderId.toString();
      return this.orderMetadataMap[orderId];
    } else {
      return null;
    }
  };

  SupportOrderModel.prototype.setOrderMetaData = function(orderId, metadata) {
    if (orderId && metadata) {
      orderId = orderId.toString();
      return this.orderMetadataMap[orderId] = metadata;
    }
  };

  SupportOrderModel.prototype.getOrderDetailsForMygrouponsOrderId = function(successCallback, errorCallback) {
    var orderIdFromMyGroupons, requests;
    if (!window.orderIdFromMyGroupons) {
      return errorCallback();
    }
    orderIdFromMyGroupons = window.orderIdFromMyGroupons;
    requests = {
      orderDetailsMyGrouponOrder: (function(_this) {
        return function(cb) {
          var _errorCb, _successCb, order, params;
          params = {
            order: {
              id: orderIdFromMyGroupons
            },
            forceFetchOrderDetails: true
          };
          if (orderIdFromMyGroupons != null) {
            order = Groupon.Support.OrdersCollection.findOrderById(orderIdFromMyGroupons);
            if (order) {
              params.order = order;
              params.forceFetchOrderDetails = false;
            }
          }
          _successCb = function(response) {
            return cb(null, response);
          };
          _errorCb = function() {
            return cb(null, null);
          };
          return _this.getOrderDetails(params, _successCb, _errorCb);
        };
      })(this),
      orderDetailsFirstOrder: (function(_this) {
        return function(cb) {
          var _errorCb, _successCb, paramOrder, params;
          paramOrder = Groupon.Support.currentOrdersFilter.getFirstOrder();
          if ((paramOrder != null ? paramOrder.id : void 0) && orderIdFromMyGroupons && (paramOrder != null ? paramOrder.id.toString() : void 0) === orderIdFromMyGroupons.toString()) {
            return cb(null, null);
          }
          params = {
            order: paramOrder,
            forceFetchOrderDetails: false
          };
          _successCb = function(response) {
            return cb(null, response);
          };
          _errorCb = function() {
            return cb(null, null);
          };
          return _this.getOrderDetails(params, _successCb, _errorCb);
        };
      })(this)
    };
    return async.parallel(requests, (function(_this) {
      return function(err, results) {
        if (err) {
          return errorCallback();
        } else {
          if (results.orderDetailsMyGrouponOrder != null) {
            window.selectOrderFromMygroupons = true;
            return successCallback(results.orderDetailsMyGrouponOrder);
          } else if (results.orderDetailsFirstOrder) {
            window.selectOrderFromMygroupons = false;
            return successCallback(results.orderDetailsFirstOrder);
          } else {
            return errorCallback();
          }
        }
      };
    })(this));
  };

  SupportOrderModel.prototype.getOrderDetails = function(params, successCallback, errorCallback) {
    var _orderDetailSuccessCallback, _orderDetailsErrorCallback, orderDetails, orderSummary, ref, ref1, url;
    orderSummary = params.order;
    orderDetails = this.findOrderDetailsByOrderId(orderSummary != null ? orderSummary.id : void 0);
    if (orderDetails && (!params.forceFetchOrderDetails)) {
      return successCallback(orderDetails);
    }
    _orderDetailSuccessCallback = (function(_this) {
      return function(orderDetails) {
        orderDetails.isOrderDetailsFetched = true;
        _this.setOrderDetails(orderDetails);
        _this.associateHotelImages(orderDetails);
        return successCallback(orderDetails);
      };
    })(this);
    _orderDetailsErrorCallback = function() {
      return errorCallback(orderSummary);
    };
    if (checkIfIsUSByCountry(window.country.name)) {
      url = (function() {
        switch (orderSummary.DEAL_TYPE) {
          case 'GETAWAYS_MARKET_RATE':
            return this.getawaysHotelReservationDetailsPath(orderSummary.id);
          case 'GETAWAYS_TONIGHT':
            return this.getawaysHotelReservationDetailsPath(orderSummary.id);
          default:
            return this.orderDetailsPath(orderSummary, params);
        }
      }).call(this);
      return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
    } else if (window.isNeedish()) {
      params.forceFetchOrderDetails = true;
      url = this.orderDetailsPath(orderSummary, params);
      return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
    } else {
      if (((ref = orderSummary.deal) != null ? ref.isTravelBookableDeal : void 0) || ((ref1 = orderSummary.deal) != null ? ref1.isBookableTravelDeal : void 0)) {
        return _orderDetailSuccessCallback(orderSummary);
      }
      if (orderSummary.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
        url = this.getawaysHotelReservationDetailsPath(orderSummary.id);
        return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
      } else if (params.forceFetchOrderDetails) {
        url = this.orderDetailsPath(orderSummary, params);
        return SupportAPIHelper.get(url, null, _orderDetailSuccessCallback, _orderDetailsErrorCallback, false);
      } else {
        return this.getDealInfo(params, successCallback, errorCallback);
      }
    }
  };

  SupportOrderModel.prototype.getDealInfo = function(params, successCallback, errorCallback) {
    var _dealInfoErrorCallback, _dealInfoSuccessCallback, orderDetails, url;
    orderDetails = params.order;
    if (orderDetails.isDealDataFetched) {
      return successCallback(orderDetails);
    }
    _dealInfoSuccessCallback = (function(_this) {
      return function(deal) {
        _.extend(orderDetails.deal, deal);
        if (deal.DEAL_TYPE != null) {
          orderDetails.DEAL_TYPE = deal.DEAL_TYPE;
        }
        orderDetails.finePrintText = deal.finePrintText;
        orderDetails.isDealDataFetched = true;
        return successCallback(orderDetails);
      };
    })(this);
    _dealInfoErrorCallback = function() {
      return errorCallback(orderDetails);
    };
    url = this.dealDetailsPath(orderDetails.deal.id);
    return SupportAPIHelper.get(url, {
      purchasedAt: orderDetails.purchasedAt
    }, _dealInfoSuccessCallback, _dealInfoErrorCallback, false);
  };

  SupportOrderModel.prototype.getMetadata = function(params, successCallback, errorCallback) {
    var _metadataSuccessCallback, metadataResponse, metadataUrl, orderData, orderDetails;
    orderDetails = params.order;
    _metadataSuccessCallback = (function(_this) {
      return function(response) {
        orderDetails.isMetaDataFetched = true;
        _this.setOrderMetaData(orderDetails != null ? orderDetails.id : void 0, response);
        return _this.setCurrentOrderAttributes({
          orderDetails: orderDetails,
          orderMetadata: response
        }, successCallback);
      };
    })(this);
    metadataResponse = this.findOrderMetaDataByOrderId(orderDetails != null ? orderDetails.id : void 0);
    if (metadataResponse != null) {
      return _metadataSuccessCallback(metadataResponse);
    }
    metadataUrl = window.SUPPORTBASEURL + "/metadata?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
    orderData = {
      groupon: orderDetails,
      channel: orderDetails.DEAL_TYPE
    };
    orderDetails.user = currentUser;
    return SupportAPIHelper.call(metadataUrl, 'POST', orderData, _metadataSuccessCallback, errorCallback, false);
  };

  SupportOrderModel.prototype.setCurrentOrderAttributes = function(arg, callback) {
    var orderDetails, orderMetadata;
    orderMetadata = arg.orderMetadata, orderDetails = arg.orderDetails;
    orderDetails.serviceActions = orderMetadata.serviceActions;
    orderDetails.tagLine = orderMetadata.tagLine;
    if (orderMetadata.priorityTaglines != null) {
      orderDetails.priorityTaglines = orderMetadata.priorityTaglines;
    }
    if (orderMetadata.finePrintText != null) {
      orderDetails.finePrintText = orderMetadata.finePrintText;
    }
    if (orderMetadata.status != null) {
      Groupon.Support.ContentModel.displayStatus = orderMetadata.status;
    }
    if (orderMetadata.notes != null) {
      Groupon.Support.ContentModel.displayNotes = orderMetadata.notes;
    }
    if (orderMetadata.external_notes != null) {
      Groupon.Support.ContentModel.externalDealNotes = orderMetadata.external_notes;
    }
    if (orderMetadata.shouldShowDeliveryMsg != null) {
      orderDetails.shouldShowDeliveryMsg = orderMetadata.shouldShowDeliveryMsg;
    } else {
      orderDetails.shouldShowDeliveryMsg = false;
    }
    if (orderMetadata.goodsDealFulfillmentTag != null) {
      orderDetails.goodsDealFulfillmentTag = orderMetadata.goodsDealFulfillmentTag;
    }
    if (orderMetadata.isRefundEligible != null) {
      orderDetails.isRefundEligible = orderMetadata.isRefundEligible;
    }
    if (orderMetadata.escalateToMerchant != null) {
      orderDetails.escalateToMerchant = orderMetadata.escalateToMerchant;
    }
    if (orderMetadata.isChannelEligibleForMerchantContact != null) {
      orderDetails.isChannelEligibleForMerchantContact = orderMetadata.isChannelEligibleForMerchantContact;
    }
    orderDetails.expectedDeliveryDate = orderMetadata.expectedDeliveryDate;
    orderDetails.remainingDeliveryDays = orderMetadata.remainingDeliveryDays;
    if ($.inArray('edit_order', orderDetails.serviceActions) > -1 || $.inArray('cancel_order', orderDetails.serviceActions) > -1 || $.inArray('cancel_reservations', orderDetails.serviceActions) > -1) {
      orderDetails.isEditable = true;
      orderDetails.isEditableUntil = orderMetadata.editableUntillongDateTimeStr;
      orderDetails.editableUntilshortDateTimeStr = orderMetadata.editableUntilshortDateTimeStr;
      orderDetails.editableUntillongDateTimeStr = orderMetadata.editableUntillongDateTimeStr;
    } else {
      orderDetails.isEditable = false;
    }
    if ((orderMetadata != null ? orderMetadata.inbentaParams : void 0) != null) {
      Groupon.Support.ContentModel.extendParams(orderMetadata.inbentaParams);
    }
    return callback(orderDetails);
  };

  SupportOrderModel.prototype.associateHotelImages = function(order) {
    var reservationSource, savedData;
    if (order.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
      savedData = Groupon.Support.OrdersCollection.getHotelImageByOrderId(order.id);
      reservationSource = SupportUtilsHelper.getReservationSource(order);
      if ((reservationSource != null) && savedData) {
        reservationSource.images = savedData.images;
      }
    }
    return order;
  };

  SupportOrderModel.prototype.dealDetailsPath = function(dealId) {
    return window.SUPPORTBASEURL + "/deal/" + dealId;
  };

  SupportOrderModel.prototype.orderDetailsPath = function(order, params) {
    var groupon, query, ref;
    query = "";
    if (order != null) {
      if (((ref = order.groupons) != null ? ref.length : void 0) > 0) {
        groupon = _.first(order.groupons);
        if (groupon.id) {
          query = query + "groupon_id=" + groupon.id + "&";
        }
      }
    }
    if (params) {
      if (params.isRefundEligible) {
        query = query + "is_refund_eligible=true&";
      }
      if (params.forceFetchOrderDetails) {
        query = query + "mygroupon_show=true&";
      }
    }
    return window.SUPPORTBASEURL + "/user/" + currentUser.id + "/order/" + order.id + "?" + query;
  };

  SupportOrderModel.prototype.getawaysHotelReservationDetailsPath = function(reservationId) {
    var consumerId, parts, ref, user_id;
    if (checkIfIsUSByCountryCluster(window.country.cluster)) {
      parts = (ref = currentUser.consumerId) != null ? ref.split("-") : void 0;
      consumerId = _.reduce(parts, function(memo, part) {
        return "" + memo + part;
      });
      return window.SUPPORTBASEURL + "/user/" + consumerId + "/getaways_hotel_reservation/" + reservationId;
    } else {
      user_id = currentUser.id;
      return window.SUPPORTBASEURL + "/user/" + user_id + "/getaways_hotel_reservation/" + reservationId;
    }
  };

  return SupportOrderModel;

})(Backbone.Model);

module.exports = SupportOrderModel;

//# sourceMappingURL=data:application/json;base64,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
